module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/258.98dba392.png";